import { useState } from "react";
import {
  Button,
  CustomSelect,
  FormFieldSet,
  Modal,
} from "../../../../components";
import { getDatesByOption } from "../../../../utils/wf/date";
import { DATE_RANGE_OPTIONS } from "../../../../assets/data/enumData";
import ReservedUploadModal from "./ReservedUploadModal";
import ActivityModal from "./ActivityModal";
import { getPaginationRange } from "../../../../components/Table/TableAdv/TableSettings";
import selectOpionGenerator from "../../../../components/Table/TableAdv/tableUtils/selectOpionGenerator";

const fmt = (n) =>
  n != null
    ? n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "";

const fmtZ = (n) =>
  (n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const isNeg = (n) => n != null && n < 0;

function EntryBlock({ entry, isLast }) {
  return (
    <>
      {/* Entry header row */}
      <tr>
        <td className="px-2 py-1 text-sm whitespace-nowrap text-gray-800 text-center">
          {entry?.date}
        </td>
        <td className="px-2 py-1 text-sm whitespace-nowrap text-gray-800 text-center">
          {entry?.type}
        </td>
        <td className="px-2 py-1 text-sm whitespace-nowrap text-gray-800 text-center">
          {entry?.description}
        </td>
        <td className="px-2 py-1 text-sm whitespace-nowrap text-gray-800 text-center">
          {entry?.invoiceNo}
        </td>
        <td className="px-2 py-1 text-sm whitespace-nowrap text-gray-800 text-center">
          {entry?.reference}
        </td>
        <td colSpan={9}></td>
      </tr>

      {/* Detail rows */}
      {entry?.rows?.map((r, i) => (
        <tr key={i} className="hover:bg-gray-50 transition-colors">
          <td className="px-2 py-1 text-sm"></td>
          <td className="px-2 py-1 text-sm"></td>
          <td className="px-2 py-1 text-sm"></td>
          <td className="px-2 py-1 text-sm text-center text-gray-700">
            {r?.invoiceNo}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-700">
            {r?.reference}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-700">
            {r?.customer}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-700">
            {r?.buyDate}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-600">
            {r?.daysOpen}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-700">
            {r?.activityType}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-800">
            {r?.appliedAR}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-800">
            {r?.appliedAdvance}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-800">
            {r?.appliedFee}
          </td>
          <td className="px-2 py-1 text-sm text-center text-gray-600">
            {r?.feePct}
          </td>
          <td
            className={`px-2 py-1 text-sm text-center whitespace-nowrap text-gray-600`}
          >
            {/* <td className={`px-2 py-1 text-sm text-center whitespace-nowrap ${isNeg(r.reserveAmount) ? "text-red-500" : "text-gray-800"}`}> */}
            {r?.reserveAmount != null
              ? isNeg(r?.reserveAmount)
                ? `(${Math.abs(r?.reserveAmount)?.toFixed(2)})`
                : r?.reserveAmount?.toFixed(2)
              : ""}
          </td>
        </tr>
      ))}

      {/* Entry total */}
      <tr className={!isLast ? "border-b border-gray-400" : ""}>
        <td
          colSpan={8}
          className="px-2 py-1 text-sm font-bold text-right text-gray-700"
        ></td>
        <td className="px-2 py-1 text-sm font-bold text-center text-gray-700">
          Total
        </td>
        <td className="px-2 py-1 text-sm text-center font-semibold text-primary-500 whitespace-nowrap">
          {entry?.total?.appliedAR}
        </td>
        <td className="px-2 py-1 text-sm text-center font-semibold text-primary-500 whitespace-nowrap">
          {entry?.total?.appliedAdvance}
        </td>
        <td className="px-2 py-1 text-sm text-center font-semibold text-primary-500 whitespace-nowrap">
          {entry?.total?.appliedFee}
        </td>
        <td className="px-2 py-1 text-sm"></td>
        <td className="px-2 py-1 text-sm text-center font-semibold text-primary-500 whitespace-nowrap">
          {entry?.total?.reserveAmount}
        </td>
      </tr>

      <tr>
        <td colSpan={14} className="h-1"></td>
      </tr>
    </>
  );
}

function ClientBlock({ client, isLast }) {
  return (
    <>
      {client?.entries?.map((entry, i) => (
        <EntryBlock key={i} entry={entry} isLast={isLast} />
      ))}

      {/* Client Total */}
      {/* <tr className="bg-primary-50">
        <td
          colSpan={8}
          className="px-2 py-1.5 text-sm font-bold text-right text-gray-800"
        ></td>
        <td className="px-2 py-1.5 text-sm font-bold text-center text-gray-800">
          Client Total
        </td>
        <td className="px-2 py-1.5 text-sm text-center font-bold text-primary-500 whitespace-nowrap">
          {fmtZ(client.clientTotal.appliedAR)}
        </td>
        <td className="px-2 py-1.5 text-sm text-center font-bold text-primary-500 whitespace-nowrap">
          {fmtZ(client.clientTotal.appliedAdvance)}
        </td>
        <td className="px-2 py-1.5 text-sm text-center font-bold text-primary-500 whitespace-nowrap">
          {fmtZ(client.clientTotal.appliedFee)}
        </td>
        <td className="px-2 py-1.5 text-sm"></td>
        <td className="px-2 py-1.5 text-sm text-center font-bold text-primary-500 whitespace-nowrap">
          {fmtZ(client.clientTotal.reserveAmount)}
        </td>
      </tr> */}

      <tr>
        <td colSpan={14} className=""></td>
      </tr>
    </>
  );
}
export const ReservedModalTable = ({ rows, columns }) => {
  const [data] = useState(rows);
  const DEFAULT_LIST = [10, 20, 30];
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const totalPages = Math.ceil(data?.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRecords = data?.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (val) => {
    setRowsPerPage(Number(val));
    setCurrentPage(1);
  };

  const toNum = (v) => {
    if (v == null || v === "") return 0;
    const cleaned = String(v)
      .replace(/,/g, "")
      .replace(/[^\d.-]/g, "");
    const num = Number(cleaned);
    return Number.isFinite(num) ? num : 0;
  };
  const grandTotal = currentRecords?.reduce(
    (acc, entry) => ({
      appliedAR: acc?.appliedAR + toNum(entry?.total?.appliedAR),
      appliedAdvance:
        acc?.appliedAdvance + toNum(entry?.total?.appliedAdvance),
      appliedFee: acc?.appliedFee + toNum(entry?.total?.appliedFee),
      reserveAmount:
        acc?.reserveAmount + toNum(entry?.total?.reserveAmount),
    }),
    { appliedAR: 0, appliedAdvance: 0, appliedFee: 0, reserveAmount: 0 },
  );
  const pages = getPaginationRange(currentPage, totalPages);

  return (
    <div className="bg-white min-h-full">
      <div className="py-2 px-2 flex items-center gap-2 text-sm flex-wrap">
        <span>
          {!data.length ? startIndex : startIndex + 1}–
          {Math.min(endIndex, data.length)}
        </span>
        <span className="text-nowrap">of {data?.length}</span>

        <Button
          size="sm"
          type="icon"
          variant="text"
          color="black"
          icon="chevron_left"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          data-dropdown-persist="true"
        />

        <div className="flex items-center">
          {pages?.map((page, index) =>
            page === "..." ? (
              <span key={`ellipsis-${index}`} className="px-0! text-gray-400">
                ...
              </span>
            ) : (
              <Button
                key={`page-${page}-${index}`}
                size="sm"
                variant={currentPage === page ? "contained" : "text"}
                color={currentPage === page ? "primary" : "black"}
                title={String(page)}
                className="min-w-[20px] !px-0 !py-0"
                onClick={() => handlePageChange(page)}
                data-dropdown-persist="true"
              />
            ),
          )}
        </div>

        <Button
          size="sm"
          icon="chevron_right"
          type="icon"
          variant="text"
          color="black"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          data-dropdown-persist="true"
        />

        <div className="w-32 lg:w-40">
          <CustomSelect
            size="sm"
            placeholder="Select rows"
            options={selectOpionGenerator(DEFAULT_LIST, rowsPerPage)}
            selected={String(rowsPerPage)}
            onChange={handleRowsPerPageChange}
            data-dropdown-persist="true"
          />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border">
          <thead>
            <tr className="border-t-2 border-b-2 border-gray-900 bg-primary-50">
              {columns?.map(({ label }, i) => (
                <th
                  key={i}
                  className="px-2 py-5 text-xs font-bold whitespace-nowrap leading-tight align-bottom text-center"
                >
                  {label?.map((line, j) => (
                    <span key={j} className="block">
                      {line}
                    </span>
                  ))}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRecords?.map((entry, i) => (
              <EntryBlock
                key={i}
                entry={entry}
                isLast={i === currentRecords?.length - 1}
              />
            ))}

            {/* Grand Total */}
            <tr className="bg-primary-50 border-b-2 border-primary-300">
              <td
                colSpan={8}
                className="px-2 py-1.5 text-sm font-bold text-right text-gray-800"
              ></td>
              <td className="px-2 py-1.5 text-sm font-bold text-center text-gray-800 text-nowrap">
                Grand Total
              </td>
              <td className="px-2 py-1.5 text-sm text-center font-bold text-primary-500 whitespace-nowrap">
                {grandTotal?.appliedAR}
              </td>
              <td className="px-2 py-1.5 text-sm text-center font-bold text-primary-500 whitespace-nowrap">
                {grandTotal?.appliedAdvance}
              </td>
              <td className="px-2 py-1.5 text-sm text-center font-bold text-primary-500 whitespace-nowrap">
                {grandTotal?.appliedFee}
              </td>
              <td className="px-2 py-1.5 text-sm"></td>
              <td className="px-2 py-1.5 text-sm text-center font-bold text-primary-500 whitespace-nowrap">
                {grandTotal?.reserveAmount}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const ReservedFilterBar = ({
  setActivityOpen,
  activityOpen,
  formData,
  handleChange,
  setReservedUpload,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const isCustomRange = formData?.reportPeriod === "custom";

  const handleDateRangeSelect = (val) => {
    handleChange("reportPeriod", val);

    if (val === "custom") {
      handleChange("fromDate", null);
      handleChange("toDate", null);
    } else {
      const range = getDatesByOption(val);
      if (range) {
        handleChange("fromDate", range?.from);
        handleChange("toDate", range?.to);
      }
    }
    setShowDropdown(false);
  };

  return (
    <>
      <div className="bg-white py-3 flex items-end gap-3 flex-wrap">
        {/* Date Range Select */}
        <FormFieldSet
          title="Report Period"
          placeholder="select Date Range"
          type="select"
          options={DATE_RANGE_OPTIONS}
          value={formData?.reportPeriod}
          onChange={handleDateRangeSelect}
          showDropdown={showDropdown}
          // onClick={() => setShowDropdown(true)}
        />

        {/* From - Only for Custom */}
        {isCustomRange && (
          <FormFieldSet
            title="From"
            type="datepicker"
            placeholder="select Date"
            value={formData?.fromDate}
            onChange={(val) => handleChange("fromDate", val)}
            showDropdown={false}
          />
        )}

        {/* To - Only for Custom */}
        {isCustomRange && (
          <FormFieldSet
            title="To"
            type="datepicker"
            placeholder="select Date"
            value={formData?.toDate}
            onChange={(val) => handleChange("toDate", val)}
            showDropdown={false}
            minDate={
              formData?.fromDate ? new Date(formData?.fromDate) : undefined
            }
          />
        )}

        <FormFieldSet
          noTitle
          type="text"
          placeholder="search"
          value={formData?.search}
          onChange={(val) => handleChange("search", val)}
        />

        <div className="flex-1" />

        <Button
          title={"Activity"}
          variant={"outlined"}
          onClick={() => setActivityOpen(true)}
        />
        <Button
          icon={"upload"}
          title={"Upload"}
          onClick={() => setReservedUpload(true)}
        />
      </div>

      <Modal
        isOpen={activityOpen}
        onClose={() => setActivityOpen(false)}
        title="Activity"
        width="max-w-7xl"
        titleColor={"primary"}
        zIndex={55}
      >
        <ActivityModal
          isOpen={activityOpen}
          onClose={() => setActivityOpen(false)}
          type={"Reserve Detail Report"}
        />
      </Modal>
    </>
  );
};
